import Paper from "@material-ui/core/Paper";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { isMobile } from "react-device-detect";
import { ARTICLES, FONTS, SECONDARY_COLOR } from "../constants";
import sale from "../media/acquisition.svg";
import bar from "../media/bar-chart.svg";
import churn from "../media/career.svg";
import credit from "../media/credit-card.svg";
import fraud from "../media/fraud.svg";
import home from "../media/price-up.svg";
import purchase from "../media/purchase.svg";
import { stateType, stateTypeF } from "../state";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			height: isMobile ? "2120px" : "750px",
			display: "flex",
			flexDirection: "column",
			width: "100vw",
			alignItems: "center",
			backgroundColor: "white", //"#212b5a",
			marginTop: "-30px",
			boxShadow: "rgba(21, 32, 52, 0.35) 0px 2px 6px;",
			zIndex: 0,
		},
		examplesWrapper: {
			display: "flex",
			flexDirection: isMobile ? "column" : "row",
			alignItems: "center",
			marginTop: isMobile ? "20px" : "40px",
		},
		title: {
			fontFamily: FONTS,
			fontSize: "32px",
			marginTop: "30px",
			color: SECONDARY_COLOR,
		},
		example: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			marginLeft: isMobile ? "0px" : "30px",
			width: "290px",
			height: "250px",
			cursor: "default",
			marginTop: isMobile ? "20px" : "0px",
		},
		image: {
			height: "110px",
			width: "110px",
			marginTop: "15px",
		},
		exampleTitle: {
			fontFamily: FONTS,
			fontSize: "25px",
			marginTop: "15px",
		},
		description: {
			fontFamily: FONTS,
			width: "200px",
			textAlign: "center",
			marginTop: "10px",
		},
		sectionSubTitle: {
			marginTop: "0.5em",
			fontSize: "1.1em",
			textAlign: "center",
			fontFamily: FONTS,
		},
	})
);

type exampleType = {
	title: string;
	description: string;
	image: string;
	color: string;
};
type exampleType2 = { example: exampleType; state: stateTypeF };

let colors = [
	"#333C83",
	"#F24A72",
	"#FDAF75",
	"#6BCB77",
	"#4D96FF",
	"#8843F2",
	"#005792",
];

colors = [
	"white",
	"white",
	"white",
	"white",
	"white",
	"white",
	"white",
	"white",
];

export const examples: exampleType[] = [
	{
		title: ARTICLES.sales_leads,
		description: "Rank sales prospects by likiness to buy.",
		image: sale,
		color: colors[0],
	},
	{
		title: ARTICLES.finance,
		description: "Inform your investment decisions.",
		image: bar,
		color: colors[1],
	},
	{
		title: ARTICLES.csat,
		description: "Predict customers likely to churn, and take action.",
		image: churn,
		color: colors[2],
	},
	{
		title: ARTICLES.purchase,
		description: "Offer the right product to the right customer.",
		image: purchase,
		color: colors[3],
	},
];

export const examples2: exampleType[] = [
	{
		title: ARTICLES.fraud,
		description: "Detect high-likelihood fraud accounts.",
		image: fraud,
		color: colors[4],
	},
	{
		title: ARTICLES.property,
		description: "Develope property pricing models.",
		image: home,
		color: colors[5],
	},
	{
		title: ARTICLES.credit,
		description: "Determine the likelihood of loan repayment/default.",
		image: credit,
		color: colors[6],
	},
];

export function Example({ example, state }: exampleType2) {
	let classes = useStyles();

	const onMouseOver = () => {
		const exState = state.getExHoverState();
		exState.set(example.title, 20);
		state.setExHoverState(exState);
	};
	const onMouseOut = () => {
		const exState = state.getExHoverState();
		exState.set(example.title, 3);
		state.setExHoverState(exState);
	};

	let hoverVal = state.getExHoverState().get(example.title);
	return (
		<Paper
			className={classes.example}
			elevation={hoverVal}
			onMouseOver={onMouseOver}
			onMouseOut={onMouseOut}
		>
			<div className={classes.exampleTitle}>{example.title}</div>
			<img src={example.image} className={classes.image}></img>
			<div className={classes.description}>{example.description}</div>
		</Paper>
	);
}

export function UseCases({ state }: stateType) {
	let classes = useStyles();

	return (
		<div className={classes.wrapper}>
			<div className={classes.title}>Application Examples</div>{" "}
			<div className={classes.sectionSubTitle}>
				{isMobile
					? "How you can put Dash AI to work"
					: "Check out some example applications of Dash AI"}
			</div>
			<div className={classes.examplesWrapper}>
				{examples.map((ex) => (
					<Example example={ex} state={state}></Example>
				))}
			</div>
			<div className={classes.examplesWrapper}>
				{examples2.map((ex) => (
					<Example example={ex} state={state}></Example>
				))}
			</div>
		</div>
	);
}
